import React from "react";
import styles from "./modal-right.module.css";
import Stat from "./stat";
import { v4 } from "uuid";
import Event from "./event";
import getImageFileName from "../../../../functions/getImageFileName";
import { getUIText } from "../../../../translation";
import { changeColorTagToSpan, replaceColorTag } from "../../../../functions/stringFunctions";
import { LOCALES } from "../../../../constants";

export default function ModalRight({ lang, selected, levelFlag }) {
    return (
        <div className={styles["modal-right"]}>
            <div className={styles["base-info-wrapper"]}>
                <div className={styles["arcana-image"]}>
                    <img src={`${process.env.PUBLIC_URL}/images/cards/${getImageFileName(selected.name[[LOCALES.KO]])}.webp`} />
                </div>
                <div className={styles["base-info"]}>
                    <div className={styles["modal-header"]}>
                        <h2>{selected.name[lang]}</h2>
                        <div className={styles["badges"]}>
                            <span className={`${styles["rarity-badge"]} ${styles[selected.rarity]}`}>{selected.rarity}</span>
                            <p className="char-name">{selected.charName[lang]}</p>
                        </div>
                    </div>
                    <div className={styles["group"]}>
                        <h3>{getUIText(lang, "arcana.card.modal.type.title")}</h3>
                        <div className={styles["badges"]}>
                            <span className={`${styles["badge"]} ${styles["training"]}`}>{selected.mainStat[lang]}</span>
                            {selected.assists.length > 0 && (
                                <span className={`${styles["badge"]} ${styles["support"]}`}>{selected.assists[0][lang]}</span>
                            )}
                            {selected.assists.length > 0 && (
                                <span className={`${styles["badge"]} ${styles["support"]}`}>{selected.assists[1][lang]}</span>
                            )}
                        </div>
                    </div>
                    {(selected.spPotential || selected.uniqueEffect) && (
                        <div className={styles["group"]}>
                            <h3>{getUIText(lang, "arcana.card.modal.uniqueAbility")}</h3>
                            <div className={styles["group-info"]}>
                                {selected.spPotential && (
                                    <div className={styles["box"]}>
                                        <div className={styles["title"]}>
                                            {getUIText(lang, "arcana.card.modal.spPotential")} : {selected.spPotential.name[lang]}
                                        </div>
                                        <div
                                            className={styles["desc"]}
                                            dangerouslySetInnerHTML={{ __html: replaceColorTag(selected.spPotential.desc[lang]) }}
                                        ></div>
                                    </div>
                                )}
                                {selected.uniqueEffect && (
                                    <div className={styles["box"]}>
                                        <div className={styles["title"]}>
                                            {getUIText(lang, "arcana.card.modal.uniqueEffect")} : {selected.uniqueEffect.name[lang]}
                                        </div>
                                        <div
                                            className={styles["desc"]}
                                            dangerouslySetInnerHTML={{ __html: changeColorTagToSpan(selected.uniqueEffect.desc[lang]) }}
                                        ></div>
                                        {/* <div className={styles["desc"]}>{selected.uniqueEffect.desc[lang]}</div> */}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {selected.stats.journeyStartStats.length > 0 && (
                <div className={styles["group"]}>
                    <h3>{getUIText(lang, "arcana.card.modal.startEffect")}</h3>
                    <div className={`${styles["group-info"]} ${styles["row"]}`}>
                        {selected.stats.journeyStartStats.map((stat) => {
                            return (
                                <div className={styles["box"]} key={v4()}>
                                    <Stat lang={lang} obj={stat} levelFlag={levelFlag} isThin={false} mainStat={selected.mainStat[lang]} />
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            <div className={styles["group"]}>
                <h3>{getUIText(lang, "arcana.card.modal.additionalEffect")}</h3>
                <div className={`${styles["group-info"]} ${styles["grid"]}`}>
                    {selected.stats.trainingEffects.length > 0 && (
                        <div className={styles["box"]}>
                            <div className={styles["title"]}>{getUIText(lang, "arcana.card.modal.trainingEffect")}</div>
                            {selected.stats.trainingEffects.map((stat) => {
                                return <Stat lang={lang} obj={stat} levelFlag={levelFlag} isThin={true} key={v4()} />;
                            })}
                        </div>
                    )}
                    {selected.stats.telepathyEffects.length > 0 && (
                        <div className={styles["box"]}>
                            <div className={styles["title"]}>{getUIText(lang, "arcana.card.modal.telepathyEffect")}</div>
                            {selected.stats.telepathyEffects.map((stat) => {
                                return <Stat lang={lang} obj={stat} levelFlag={levelFlag} isThin={true} key={v4()} />;
                            })}
                        </div>
                    )}
                    {selected.stats.supportQuestEffects.length > 0 && (
                        <div className={styles["box"]}>
                            <div className={styles["title"]}>{getUIText(lang, "arcana.card.modal.supportQuestEffect")}</div>
                            {selected.stats.supportQuestEffects.map((stat) => {
                                return <Stat lang={lang} obj={stat} levelFlag={levelFlag} isThin={true} key={v4()} />;
                            })}
                        </div>
                    )}
                </div>
            </div>
            <div className={styles["group"]}>
                <h3>{getUIText(lang, "arcana.card.modal.event.title")}</h3>
                <div className={styles["events"]}>
                    {selected.events.map((event) => {
                        return <Event lang={lang} event={event} key={v4()} />;
                    })}
                </div>
            </div>
        </div>
    );
}
